<div class="esf-info-tile esf-info-tile--full-width">
  <div class="esf-info-tile__content">

    <ng-container *ngIf="!spinnerLoading">
      <table class="esf-table"
             *ngIf="invoiceList?.length"
             app-table
             [limitResults]="limitDisplayResults"
             [columns]="columns"
             [keys]="keys"
             [data]="invoiceList"
             (rowClickEvent)="openInvoice($event)">
      </table>
      <section class="esf-empty-state"
               *ngIf="!invoiceList?.length"
               app-empty-state
               [emptyStateIcon]="'#esf-icon-ticket'"
               [emptyStateText]="tixxReservationsTimedOut ? tablesTranslations.i18nTooManyReservations : tablesTranslations.i18nNoReservations">
      </section>
    </ng-container>

    <section class="esf-empty-state flex-empty-state" *ngIf="spinnerLoading">
      <app-spinner [name]="spinnerName" [(show)]="spinnerLoading"></app-spinner>
    </section>
  </div>

  <div class="esf-info-tile__show-all" *ngIf="invoiceList?.length >= limitDisplayResults">
    <button class="esf-button esf-button--simple" [routerLink]="['ticketing']" [state]="{tab: 'reservations'}">
      <span class=" esf-button__icon-text-right-12" i18n="Action button@@general.button.showAll">Show all</span>
      <svg class="esf-icon esf-button__icon esf-button__icon-right" width="12" height="12">
        <use xlink:href="#esf-icon-arrow-right"></use>
      </svg>
    </button>
  </div>

</div>
